import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

interface IProps {
  history?: any;
}
/*
 * This custom ScrollToTop component listens to any changes in the URL
 * and scrolls back to the top of the page.
 */

const ScrollToTop: React.FC<IProps> = (props: IProps) => {
  const { history } = props;

  useEffect(() => {
    const unListen = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unListen();
    };
  }, [history]);

  return null;
};

export default withRouter(ScrollToTop);
